const LABELS = {live: 'Live', connecting: 'Connecting…', reconnecting: 'Reconnecting…'};

export default function ConnectionLabel({status}) {
    return <span className={`chat-connection is-${status}`}><i />{LABELS[status] || status}</span>;
}
